export const toDayjsLocale = (lng: string) => {
  const norm = lng.replace('_', '-').toLowerCase();

  const directMap: Record<string, string> = {
    'en-us': 'en',
    'es-es': 'es',
  };

  return directMap[norm] || norm;
};
